import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

export function render() {
  const borders = document.querySelectorAll("[data-draw]");

  borders.forEach((el) => {
    if (window.innerWidth > 1024) {
      const direction = el.getAttribute("data-draw");
      const isHorizontal = direction == "horizontal" || false;
      const size = isHorizontal
        ? el.parentNode.offsetWidth
        : el.parentNode.offsetHeight;

      let tl = gsap.timeline({
        scrollTrigger: {
          end: "+=" + window.innerHeight / (size / 720),
          scroller: ".smooth-scroll",
          scrub: true,
          start: "top 75%",
          trigger: el,
        },
      });

      if (isHorizontal) {
        tl.to(el, { width: "100%" });
      } else {
        tl.to(el, { height: "100%" });
      }
    }
  });
}
